import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiService } from "@webapp/core/abstracts/services/base-api.service";
import { AppConfigService } from "@webapp/core/app-config/services/app-config.service";
import { ApiVersionModel } from "@webapp/core/abstracts/models/api-version.model";
import { BaseFilterModel } from "@webapp/core/abstracts/models/base-filter.model";
import { Observable } from "rxjs";
import { HttpActions } from "@webapp/core/abstracts/enums/http-actions.enum";
import { Permission, PermissionDTO } from "@webapp/permissions/models/permissions.model";

@Injectable({
  providedIn: "root",
})
export class PermissionsApiService extends BaseApiService<Permission, PermissionDTO> {
  constructor(httpClient: HttpClient, appConfigService: AppConfigService) {
    super("permissions", { ...new ApiVersionModel("v1") }, httpClient, appConfigService);
  }

  getEffectivePermissions$(filters?: BaseFilterModel): Observable<Permission[]> {
    if (!filters) {
      filters = new BaseFilterModel();
    }
    return this.httpClient.get<Permission[]>(this.getEffectivePermissionsPath(HttpActions.getAll), {
      params: this.prepareFilters(filters),
    });
  }

  getEffectivePermissionsPath(httpAction: HttpActions): string {
    return `${this.getBasePath(httpAction)}/effective`;
  }
}
